
<div
	class="flow-m-pack-group-container"
	:selected="selected"
	:tabindex="tabindex"
	@click="handleClick($event)"
>
	<div class="flow-m-pack-group-header">
		<slot name="header" />
	</div>
	<div class="flow-m-pack-group-content">
		<div class="flow-m-pack-group-content-slot">
			<slot />
		</div>
		<div class="flow-m-pack-group-content-icon">
			<Icon
				name="chevron"
				size="small"
				:rotate="expandContent ? 180 : 0"
				@click="toggleContent($event)"
			/>
		</div>
	</div>
	<div class="flow-m-pack-group-content-expanded">
		<p
			v-if="!expandContent"
			class="paragraph-1 fc-light display-flex align-items-center margin-tp-8 upper-case"
		>
			{{ footerLabel }}
		</p>
		<div v-if="expandContent" class="margin-tp-16">
			<slot name="content" />
		</div>
	</div>
	<div v-if="$slots['footer']" class="flow-m-pack-group-footer">
		<slot name="footer" />
	</div>
</div>
